import React from 'react'
import { Button, Col, Row } from 'reactstrap'
import { MdOutlineAutoFixOff, MdOutlineSignalCellularAlt } from "react-icons/md";
import { BsGrid1X2 } from "react-icons/bs";
import { HiTranslate } from "react-icons/hi";
import { GiWorld } from "react-icons/gi";
import { useNavigate } from 'react-router-dom';
import { MdAccessTime } from "react-icons/md";
import { RiBook2Line } from "react-icons/ri";
import { AiOutlineSchedule } from "react-icons/ai";
import { TbDeviceMobileCancel } from "react-icons/tb";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";






const SoftwareItems = () => {
    const navigation = useNavigate()

    return (
        <Row className='service-items'>
            <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
                <div className='item'>
                    <BsGrid1X2 color='#000000' />
                    <div className='title'><strong>Intuitive Dashboard</strong></div>
                    <div className='subtitle'><span>Manage your content with ease using our user-friendly dashboard, designed for simplicity and efficiency.</span></div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
                <div className='item'>
                    <MdOutlineAutoFixOff color='#000000' />
                    <div className='title'><strong>Seamless Integrations</strong></div>
                    <div className='subtitle'><span>Connect your CMS with your favorite tools and platforms for a streamlined workflow.</span></div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
                <div className='item'>
                    <HiTranslate color='#000000' />
                    <div className='title'><strong>Multi-Language Support</strong></div>
                    <div className='subtitle'><span>Reach a global audience with built-in support for managing content in multiple languages.</span></div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
                <div className='item'>
                    <MdOutlineSignalCellularAlt color='#000000' />
                    <div className='title'><strong>Advanced Analytics</strong></div>
                    <div className='subtitle'><span>Track user engagement and performance with detailed insights directly from your CMS.</span></div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
                <div className='item'>
                    <IoMdCheckmarkCircleOutline color='#000000' />
                    <div className='title'><strong>Customizable Themes</strong></div>
                    <div className='subtitle'><span>Tailor your website’s design with fully customizable themes to match your brand identity.</span></div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
                <div className='item'>
                    <AiOutlineSchedule color='#000000' />
                    <div className='title'><strong>Content Scheduling</strong></div>
                    <div className='subtitle'><span>Plan and automate your content publication with an easy-to-use scheduling feature.</span></div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
                <div className='item'>
                    <MdAccessTime color='#000000' />
                    <div className='title'><strong>Real-Time Collaboration</strong></div>
                    <div className='subtitle'><span>Plan and automate your content publication with an easy-to-use scheduling feature.</span></div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
                <div className='item'>
                    <TbDeviceMobileCancel color='#000000' />
                    <div className='title'><strong>Mobile Optimization</strong></div>
                    <div className='subtitle'><span>Ensure your content looks perfect on every device with built-in mobile-friendly designs.</span></div>
                </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
                <div className='item'>
                    <RiBook2Line color='#000000' />
                    <div className='title'><strong>Media Library Management</strong></div>
                    <div className='subtitle'><span>Organize and store all your media files in one central location with easy accessibility.</span></div>
                </div>
            </Col>
            <div className='center mt-4'>
                <Button className='learn-about' onClick={() => navigation('/contact')}>
                    <GiWorld size={20} /><span>Learn More About libeCMS</span>
                </Button>
            </div>
        </Row>
    )
}

export default SoftwareItems
